module.exports = __webpack_public_path__ + "img/cover1.6c00a359.jpg";